'use client';

import { AssetType } from '@vimond/services/content-discovery';
import { hasAccessToAsset } from '../utils';
import { useAuthentication } from './useAuthentication';

const useAccessToAsset = (asset: AssetType | undefined) => {
  const { jwt } = useAuthentication();

  const hasAccess = hasAccessToAsset(asset, jwt);

  return { hasAccess };
};

export default useAccessToAsset;
